<script lang="ts">
  import DistributorAccountApplicationPage from "@retailer/svelte/DistributorAccountApplication/Page.svelte";
  import { params } from "@roxi/routify";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  const applicationRes = async () => {
    let url = `/api/retailer/account_applications/${$params.id}`;

    try {
      let res = await HttpPromise({
        method: "GET",
        url: url,
      });
      return res;
    } catch (e) {
      return {};
    }
  };

  const load = async () => {
    const promises = [applicationRes()];

    let results = await Promise.all(promises);

    return {
      application: results[0],
    };
  };

</script>

{#await load()}
  <Spinner />
{:then data}
  <DistributorAccountApplicationPage
    application={data.application}
    step={Number($params.step)}
    id={Number($params.id)}
  />
{/await}
